"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterOutChildTypes = exports.updateProductsWithTypes = exports.formatProductTypeResponse = exports.convertToImmutable = exports.simplifyCTProductType = exports.commercetoolsRequestProductTypes = void 0;
const transformObject_1 = __importDefault(require("@simplisafe/ewok/transformObject"));
const monda_1 = require("@simplisafe/monda");
const immutable_1 = require("immutable");
const prop_1 = __importDefault(require("ramda/src/prop"));
const reduce_1 = __importDefault(require("ramda/src/reduce"));
const commercetools_1 = require("../secrets/commercetools");
const commercetoolsClient_1 = require("./commercetoolsClient");
/** Request product types from Commercetools */
const commercetoolsRequestProductTypes = () => (0, commercetoolsClient_1.commercetoolsFetch)({
    endpoint: `${commercetools_1.productUrl}/product-types`,
    method: 'GET'
});
exports.commercetoolsRequestProductTypes = commercetoolsRequestProductTypes;
/** Simplify a CT ProductType */
const simplifyCTProductType = (productType) => productType.map((0, transformObject_1.default)({
    id: (0, prop_1.default)('id'),
    key: (0, prop_1.default)('key'),
    name: (0, prop_1.default)('name')
}));
exports.simplifyCTProductType = simplifyCTProductType;
/** Convert simplified ProductTypes into an Immutable Map with id for keys */
exports.convertToImmutable = (0, reduce_1.default)((acc, item) => {
    const id = (0, prop_1.default)('id', item);
    return id ? acc.set(id, item) : acc;
}, (0, immutable_1.Map)({}));
/** Format the response from the product type endpoint into an Immutable Map of simplified Product Types */
const formatProductTypeResponse = (res) => res
    .chain((0, monda_1.safeProp)('results'))
    .map(exports.simplifyCTProductType)
    .map(exports.convertToImmutable)
    .orSome((0, immutable_1.Map)({}));
exports.formatProductTypeResponse = formatProductTypeResponse;
/** Add productTypes to an existing Map of products */
const updateProductsWithTypes = (types) => (products) => {
    return products.mapEntries(([k, v]) => {
        const id = v.productTypeId;
        const type = types.get(id);
        const productType = type ? type.key : '';
        return [k, {
                ...v,
                productType
            }];
    });
};
exports.updateProductsWithTypes = updateProductsWithTypes;
/** filter out any product types that include 'child' */
const filterOutChildTypes = (products) => products.filter(v => v.productType
    ? !v.productType.includes('child')
    : true);
exports.filterOutChildTypes = filterOutChildTypes;
//# sourceMappingURL=productTypes.js.map